import { useMemo } from 'react';
import { getChainMeta } from '../helpers/getChainMeta';
/**
 * @public
 */
export function useChainMeta(chainId) {
  return useMemo(function () {
    return getChainMeta(chainId);
  }, [chainId]);
}